import axios from "axios";

export const BASE_URL = "https://apiv2.shipora.io/api";
export const IMG_URL = "https://apiv2.shipora.io/api/get-images";
// export const BASE_URL = "http://localhost:3000/api";
// export const IMG_URL = "http://localhost:3000/api/get-images";

// export const BASE_URL = "https://apiv2.shipora.io/api";
// export const IMG_URL = "https://apiv2.shipora.io/api/get-images";

// http://192.168.1.14:3001/

const api = axios.create({
    baseURL: BASE_URL,
});

const addressApi = axios.create({ baseURL: BASE_URL })


const getAccessToken = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.accessToken || null;
};

// Extract from and to from user object
const getFromTo = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const from = user?.from || null;
    const to = user?.to || null;
    return { from, to };
};

// Axios request interceptor
api.interceptors.request.use((config) => {
    const token = getAccessToken();
    const { from, to } = getFromTo();

    if (token) config.headers.Authorization = `Bearer ${token}`;

    if (config.method === "get" || config.method === "delete") {
        config.params = { ...config.params, from, to };
    } else {
        config.data = { ...config.data, from, to };
    }

    return config;
}, (error) => Promise.reject(error));



addressApi.interceptors.request.use(
    (config) => {
        const token = getAccessToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);






export const refundAmountApi = async (userData) => {
    try {
        const response = await api.post(`${BASE_URL}/refund-amount`, userData)
        return response.data
    } catch (error) {
        throw error?.response?.data?.message || "failed!"
    }
}

export const signinApi = async (userData) => {
    try {
        const response = await axios.post(`${BASE_URL}/auth/vendor-signin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

export const setUserPasswordApi = async (userData) => {
    try {
        const response = await axios.post(`${BASE_URL}/auth/save-user-password-via-mail`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};



export const getCategoriesApi = async (userData) => {
    try {
        const response = await axios.post(`${BASE_URL}/get-categories-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

export const getSubCategoriesApi = async (userData) => {
    try {
        const response = await api.post(`${BASE_URL}/get-sub-categories`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


// export const addNewCategory = async (userData) => {
//     try {
//         const response = await axios.post(`${BASE_URL}/create-category`, userData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data?.message || "failed!";
//     }
// };

export const addNewCategory = async (formData) => {
    try {
        const token = getAccessToken();

        const response = await axios.post(`${BASE_URL}/create-category`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const addNewSubCategory = async (formData) => {
    try {
        const token = getAccessToken();

        const response = await axios.post(`${BASE_URL}/create-subcategory`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

// export const addNewSubCategory = async (userData) => {
//     try {
//         const response = await axios.post(`${BASE_URL}/create-subcategory`, userData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data?.message || "failed!";
//     }
// };

export const deleteCategoryApi = async (catid, userData) => {
    try {
        const response = await axios.put(`${BASE_URL}/category/${catid}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Email Template

export const getEmailTemplate = async (userData = {}) => {
    try {
        const response = await api.post(`/email-template`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Create email template

export const createEmailTemplate = async (formData) => {
    try {
        const token = getAccessToken();

        const response = await axios.post(`${BASE_URL}/email-template-create`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Delete Email Temp


export const deleteEmailTemplate = async (userData = {}) => {
    try {

        const response = await api.post(`/email-template-delete`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//get Package 



export const getPackageSizeApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-package-size`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

// export const createPackageApi = async (userData = {}) => {
//     try {
//         const response = await api.post(`/create-package-size`, userData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data?.message || "failed!";
//     }
// };


export const createPackageApi = async (formData) => {
    try {
        const token = getAccessToken();

        const response = await axios.post(`${BASE_URL}/create-package-size`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

export const deletePackageApi = async (pakid, userData = {}) => {
    try {
        const response = await api.post(`${BASE_URL}/package-size/${pakid}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Insurance Charge  

export const getInsuranceChargeApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-insurance-charge`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Create Insurance


export const getInsuranceChargesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get_insurance_charges`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};




export const createInsuranceChargesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-insurance-charge`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//get ShipmentCharges


export const getShippingChargeApi = async (userData = {}) => {
    try {
        const response = await api.post(`/shipping-charges`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Delete SHipping Charges

export const deleteShippingApi = async (shipId, userData = {}) => {
    try {
        const response = await api.post(`/shipping-charges/${shipId}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Create SHipping CHarges 


export const createShippingAPi = async (userData = {}) => {
    try {
        const response = await api.post(`/shipping-charges-create`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Update Shipping Charges

export const updateShippingApi = async (updateId, userData = {}) => {
    try {
        const response = await api.put(`/shipping-charges-update/${updateId}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Shipment Duration 


export const getShipmentTypeDurationApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-shipment-type-duration`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Create shipment type-duration

export const createShipmentTypeDurationApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-shipment-type-duration`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};




//get shipment calculator package

export const getShipmentCalApi = async (userData = {}) => {
    try {
        const response = await api.post(`/package-shipping-calculator`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//delete package


export const deleteShipCalPackage = async (userData = {}) => {
    try {
        const response = await api.post(`/shipping-calculator/delete`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


// Create Shipping Package




export const createShipmentPackageApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-package-shipping-calculator`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//update SHipping Package (calculation)


export const updateShippingPackageApi = async (userData = {}) => {
    try {
        const response = await api.post(`/update-shipping-calculator`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Package Enquiry



export const getPackageEnquiryApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-package-enquiry`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Add Follow Up Message

export const addFollowUpMessageApi = async (userData = {}) => {
    try {
        const response = await api.post(`/follow-up/add`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Change Enquiry Status 


export const changeEnquiryStatusApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-package-enquiry`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Get Follow Up Messages




export const getFollowUpsDataApi = async (userData = {}) => {
    try {
        const response = await api.post(`/follow-up/fetch`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Dashboard Api 


export const getDashboardDataApi = async (userData = {}) => {
    try {
        const response = await api.post(`/admin/shipment/dashboard-info-v2`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Get Shipment Orders

export const getShipmentOrdersApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-shipment-orders`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//update shipment order status 


export const updateOrderStatusApi = async (orderId, userData = {}) => {
    try {
        const response = await api.put(`/update-shipment-order/${orderId}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Umbrella Management Data 


export const getUmbrellaDataApi = async (userData = {}) => {
    try {
        const response = await api.post(`/umbrella`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//update umbrella status

export const updateUmbrellaStatusApi = async (userData = {}) => {
    try {
        const response = await api.post(`/change-status`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Search Umbrella Orders


export const searchUmbrellaApi = async (userData = {}) => {
    try {
        const response = await api.post(`/umbrella/get-all-orders`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const updateBulkOrderStatusApi = async (userData = {}) => {
    try {
        const response = await api.post(`/admin/update-all-orders-status`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const createContainerApi = async (userData = {}) => {
    try {
        const response = await api.post(`/umbrella/create-umbrella`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Order Categories



export const getOrderCategoriesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/fetch-categories`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

export const getOrderSubCategoriesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/fetch-subcategories`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const getOrderAllUsersApi = async (userData = {}) => {
    try {
        const response = await api.post(`/auth/get-all-users`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

export const getOrderPackageSizesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-package-size`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};



export const getOrderDeliveryAddressApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-delivery-address-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};




export const getOrderPickupAddressApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-pickup-address-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

// export const createShipmentOrderApi = async (userData = {}) => {
//     try {
//         const response = await api.post(`/create-shipment`, userData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data?.message || "failed!";
//     }
// };

export const createShipmentOrderApi = async (formData) => {
    try {
        const token = getAccessToken();

        const response = await axios.post(`${BASE_URL}/create-shipment`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Create User - Admin

export const createUserAdminApi = async (userData = {}) => {
    try {
        const response = await api.post(`/auth/create-user-admin-send-mail`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Create Pick Up Address - Admin


export const createPickupDeliveryAddressAdminApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-delivery-address-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Warehouse Address

export const getWarehouseAddressApi = async (userData = {}) => {
    try {
        const response = await api.post(`/warehouse-address`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//update warehouse address

export const updateWarehouseAddressApi = async (userData = {}) => {
    try {
        const response = await api.post(`/update-warehouse-address`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};








//Get Coupons Management 

export const getCouponsManagementApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-admin-coupons`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};





//Create Coupons

export const createAdminCouponsApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-admin-coupon`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Delete Coupons


export const deleteCoupons = async (userData = {}) => {
    try {

        const response = await api.post(`/coupon-admin-delete`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Export Orders 


export const exportShipmentOrdersApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-shipment-orders-export`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


// Hold - Cancel Reason


export const addCancelHoldApi = async (userData = {}) => {
    try {
        const response = await api.post(`/add-cancel-reason`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Customers Data


export const getAllUsersApi = async (userData = {}) => {
    try {
        const response = await api.post(`/auth/get-all-users-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Change User Status 





export const updateUserStatusApi = async (userId, userData = {}) => {
    try {
        const response = await api.put(`/auth/update-users-admin/${userId}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const handleDifferenceApi = async (userData = {}) => {
    try {
        const response = await api.post(`/create-custom-difference-payment-link`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get Charges Admin - Order Management

export const getShipChargesApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-shipment-charges-admin`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Get User Location 

export const getUserLocationsApi = async (userData = {}) => {
    try {
        const response = await addressApi.post(`/location/user`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Create USer Location


export const createUserLocationApi = async (userData = {}) => {
    try {
        const response = await addressApi.post(`/create-user-address`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Send Mail To User


export const sendMailUserApi = async (userData = {}) => {
    try {
        const response = await api.post(`/send-email-to-user`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//send mail to user with template

// export const sendMailTempToUserApi = async (userData = {}) => {
//     try {
//         const response = await api.post(`/send-email-to-user`, userData);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data?.message || "failed!";
//     }
// };

//Get Payment Page Orders

export const getPaymentOrderApi = async (userData = {}) => {
    try {
        const response = await api.post(`/get-admin-created-orders-by-status`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


//Update Payment Status

export const updatePaymentStatusApi = async (userData = {}) => {
    try {
        const response = await api.post(`/update-shipment-order-status`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Resent Payment Link

export const resentPaymentLinkApi = async (userData = {}) => {
    try {
        const response = await api.post(`/resent-payment-link`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Send Mail Umbrella 


export const sendUmbrellaMailApi = async (userData = {}) => {
    try {
        const response = await api.post(`/umbrella/send-email`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};




export const addReviewOrderAmountApi = async (userData = {}) => {
    try {
        const response = await api.post(`/add-review-order-amount-and-send-mail`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};


export const resendReviewOrderAmountApi = async (userData = {}) => {
    try {
        const response = await api.post(`/resend-review-amount`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};

//Change Password Admin
export const changeAdminPasswordApi = async (userData = {}) => {
    try {
        const response = await api.post(`/control-center-admin/change-password`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "failed!";
    }
};
